module.exports = __webpack_public_path__ + "img/wine-placeholder--large.3456d354.svg";